module.exports = __webpack_public_path__ + "static/media/linkedin.c5facea7.svg";